/**
 * Reads the case reference out of a NAVIGATE_TO_DD_CASE chat action.
 *
 * Fresh actions carry `caseAlias` — the alias the due diligence URLs are built on.
 * Actions stored in older chat messages only ever carried `caseId`, and those
 * messages are replayed as they were, so the id remains a valid fallback (the
 * API takes either, and the page rewrites the URL to the alias once it loads).
 *
 * @param data The action's data payload, if any.
 * @returns The alias or id to build the URL with, or undefined when neither is there.
 */
export const caseAliasFromAction = (
  data: Record<string, unknown> | undefined | null
): string | undefined => {
  const caseAlias = data?.["caseAlias"];
  if (typeof caseAlias === "string" && caseAlias) return caseAlias;

  const caseId = data?.["caseId"];
  return typeof caseId === "string" && caseId ? caseId : undefined;
};
